import { useLocalStore, useObserver } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components/macro';
import { countryDescriptionByCode } from '../constants/countryCodes';
import { useMst } from '../models/WithWineState';
import { AddressDisplayProps } from '../types/AddressDisplayProps';
import { parseBoolean } from '../utils/parseBoolean';
import Button from './Button';

const UnstyledAddressDisplay: React.FC<AddressDisplayProps> = ({
  className,
  selectmessage: selectMessage,
  changemessage: changeMessage,
  incompletemessage: incompleteMessage,
  hidecountry,
  hidestate,
  hidepostcode,
  hidezip,
  onEditAddress,
}) => {
  const stateTree = useMst();
  const state = useLocalStore(() => ({
    get postcode() {
      return stateTree.session?.deliveryFields?.postcode ?? '';
    },
    get state() {
      return stateTree.session?.deliveryFields?.state ?? '';
    },
    get country() {
      return stateTree.session?.deliveryFields?.country ?? '';
    },
    get countryDescription() {
      return countryDescriptionByCode.get(this.country) ?? '';
    },
    get areDeliveryFieldsComplete() {
      return stateTree.session?.areDeliveryFieldsComplete ?? false;
    },
    get changeLinkText() {
      return this.areDeliveryFieldsComplete
        ? changeMessage ?? 'Change location'
        : selectMessage ?? 'Select location';
    },
  }));

  return useObserver(() => (
    <span className={'ww-address-select-desc ' + (className || '')}>
      {state.areDeliveryFieldsComplete && (
        <span>
          {!parseBoolean(hidecountry, false) && state.countryDescription && (
            <span className="ww-address-select-country">
              {state.countryDescription}
            </span>
          )}
          {!parseBoolean(hidestate, false) && state.state && (
            <span className="ww-address-select-state">{state.state}</span>
          )}
          {!parseBoolean(hidepostcode, false) &&
            !parseBoolean(hidezip, false) &&
            state.postcode && (
              <span className="ww-address-select-postcode">
                {state.postcode}
              </span>
            )}
        </span>
      )}
      {!state.areDeliveryFieldsComplete &&
        typeof incompleteMessage !== undefined && (
          <span className="ww-incomplete-message">{incompleteMessage}</span>
        )}
      {onEditAddress && (
        <Button
          onClick={(e) => {
            e.preventDefault();
            onEditAddress && onEditAddress();
          }}
        >
          {state.changeLinkText}
        </Button>
      )}
    </span>
  ));
};

const AddressDisplay = styled(UnstyledAddressDisplay)`
  &.ww-address-select-desc > span {
    margin-right: 10px;
    vertical-align: middle;
  }
  &.ww-address-select-desc > button {
    vertical-align: middle;
  }
  &.ww-address-select-desc > span > span:not(:last-child):after {
    content: ', ';
  }
`;

export default AddressDisplay;
